export { attachmentVariables as attachmentActionVariables } from './attachmentVariables';
